import React, { useState, useEffect } from 'react';

const ProductRecommendations = ({ productId, limit = 4 }) => {
  const [recommendations, setRecommendations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRecommendations = async () => {
      try {
        const response = await fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}`);
        const data = await response.json();
        setRecommendations(data.products || []);
      } catch (error) {
        console.error('Error fetching recommendations:', error);
      } finally {
        setLoading(false);
      }
    };

    if (productId) {
      fetchRecommendations();
    }
  }, [productId, limit]);

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(price / 100);
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <div>Loading recommendations...</div>
      </div>
    );
  }

  if (recommendations.length === 0) {
    return null;
  }

  return (
    <div style={{ marginTop: '40px' }}>
      <h3 style={{ 
        fontSize: '24px', 
        fontWeight: '600', 
        marginBottom: '20px',
        textAlign: 'center'
      }}>
        You might also like
      </h3>
      
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '20px'
      }}>
        {recommendations.map(product => (
          <div key={product.id} style={{
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            overflow: 'hidden',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}>
            
            <a href={`/products/${product.handle}`} style={{ textDecoration: 'none', color: 'inherit' }}>
              {product.featured_image && (
                <div style={{ position: 'relative', overflow: 'hidden' }}>
                  <img 
                    src={product.featured_image}
                    alt={product.title}
                    style={{
                      width: '100%',
                      height: '200px',
                      objectFit: 'cover',
                      transition: 'transform 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'scale(1.05)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'scale(1)';
                    }}
                  />
                </div>
              )}
              
              <div style={{ padding: '16px' }}>
                <h4 style={{ 
                  margin: '0 0 8px 0', 
                  fontSize: '16px', 
                  fontWeight: '600',
                  lineHeight: '1.3'
                }}>
                  {product.title}
                </h4>
                
                <div style={{ marginBottom: '12px' }}>
                  {product.variants && product.variants.length > 0 && (
                    <div>
                      <span style={{ 
                        fontSize: '18px', 
                        fontWeight: 'bold', 
                        color: '#2c5aa0' 
                      }}>
                        {formatPrice(product.variants[0].price)}
                      </span>
                      {product.variants[0].compare_at_price > product.variants[0].price && (
                        <span style={{ 
                          marginLeft: '8px', 
                          fontSize: '14px', 
                          textDecoration: 'line-through',
                          color: '#666' 
                        }}>
                          {formatPrice(product.variants[0].compare_at_price)}
                        </span>
                      )}
                    </div>
                  )}
                </div>

                {product.body_html && (
                  <p style={{ 
                    margin: '0',
                    fontSize: '14px',
                    color: '#666',
                    lineHeight: '1.4',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                  }}>
                    {product.body_html.replace(/<[^>]*>/g, '')}
                  </p>
                )}
              </div>
            </a>
            
            <div style={{ padding: '0 16px 16px' }}>
              <button
                onClick={async (e) => {
                  e.preventDefault();
                  if (product.variants && product.variants[0]) {
                    try {
                      const response = await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                          id: product.variants[0].id,
                          quantity: 1
                        })
                      });

                      if (response.ok) {
                        document.dispatchEvent(new CustomEvent('cart:updated'));
                      }
                    } catch (error) {
                      console.error('Error adding to cart:', error);
                    }
                  }
                }}
                disabled={!product.variants || !product.variants[0]?.available}
                style={{
                  width: '100%',
                  padding: '10px',
                  backgroundColor: product.variants && product.variants[0]?.available ? '#2c5aa0' : '#ccc',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: product.variants && product.variants[0]?.available ? 'pointer' : 'not-allowed',
                  transition: 'background-color 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  if (product.variants && product.variants[0]?.available) {
                    e.target.style.backgroundColor = '#1e3d6f';
                  }
                }}
                onMouseLeave={(e) => {
                  if (product.variants && product.variants[0]?.available) {
                    e.target.style.backgroundColor = '#2c5aa0';
                  }
                }}
              >
                {product.variants && product.variants[0]?.available ? 'Add to Cart' : 'Sold Out'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductRecommendations;